import { useCallback } from "react";
import { Button, Flex } from "@radix-ui/themes";
import { PlusIcon } from "@radix-ui/react-icons";
import {
  CreateSampleConfigurationsParams,
  UpsertSampleConfigurationParams,
} from "@/v2/entities/sampling/Sampling.api";
import { Step } from "./Step";
import { SampleConfiguration } from "./SampleConfiguration";

export function createSampleConfiguration(): UpsertSampleConfigurationParams {
  return {
    id: Date.now(),
    numberOfTickets: 50,
    daysUntilNextRun: 7,
    qaRules: null,
    sources: ["tickets"],
    isEnabled: true,
  };
}

interface ValidateStepProps {
  value: CreateSampleConfigurationsParams;
  onChange: (value: CreateSampleConfigurationsParams) => void;
}

export function ValidateStep({ value, onChange }: ValidateStepProps) {
  const handleConfigurationChange = useCallback(
    (config: UpsertSampleConfigurationParams) =>
      onChange({
        configurations: value.configurations.map((c) =>
          c.id === config.id ? config : c
        ),
      }),
    [onChange]
  );

  return (
    <Step index={3} label="Validate" description="Set review logic">
      <Flex width={"100%"} direction={"column"} gap={"4"}>
        {value.configurations.filter((config) => config.isEnabled).map((config) => (
          <SampleConfiguration
            key={config.id}
            value={config}
            onChange={handleConfigurationChange}
          />
        ))}

        <Button
          variant="solid"
          color="gray"
          highContrast
          onClick={() => {
            onChange({
              ...value,
              configurations: [
                ...value.configurations,
                createSampleConfiguration(),
              ],
            });
          }}
        >
          <PlusIcon />
          Add Validation Set
        </Button>
      </Flex>
    </Step>
  );
}
